import { render, staticRenderFns } from "./registered_products_section.vue?vue&type=template&id=613197b3&"
import script from "./registered_products_section.vue?vue&type=script&lang=js&"
export * from "./registered_products_section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports